"use client";

import { useState } from "react";
import {
  Tabs,
  Form,
  Input,
  Button,
  Select,
  Upload,
  Tooltip,
  Divider,
  Card,
  DatePicker
} from "antd";
import {
  InfoCircleOutlined,
  PercentageOutlined,
  UploadOutlined,
  EyeOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  DownOutlined,
  SearchOutlined,
  PrinterOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import styles from "../../../../assets/styles/styles";
import "../../../../assets/styles/InterbankPlacement.css";
import RightSidebar from "../../../../components/layouts/RightSidebar";
import { labelConfig, staticConfig } from "../../operations.config";
import { connect, useDispatch } from "react-redux";
import { rightAction } from "../../../../redux/actions";
import { BOM } from "../../../../services/definedMethod";


const { TabPane } = Tabs;
const { Option } = Select;

const NewInterbankPlacement = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  const handleConfirmDeal = () => {
    // Convert to number and increment
    const nextKey = (parseInt(activeTab) + 1).toString();
    setActiveTab(nextKey);
  };

  const handlePreview = () => {
    navigate("/detail-operations-interbank-placement");
  };

  const handleGoBack=()=>{
    navigate("/operations-interbank-placement");
  }

  return (
    <MainLayout
          pageItems={staticConfig.moneyMarketInterbankPlacementBreadcrumbItems}
    >
      
      <TopContent
        pageTitle={labelConfig.manageMoneyMarketInterbankPlacement}
        createPageTitle={labelConfig.createMoneyMarketInterbankPlacement}
      />

      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        tabBarStyle={{
          marginBottom: "24px",
        }}
        className="booking-initiation-tab "
      >

        <TabPane
          tab={
            <span
              style={{
                color: activeTab === "1" ? "#9F1AB1" : "inherit",
                backgroundColor: activeTab === "1" ? "#FDF4FF" : "",
                fontWeight: activeTab === "1" ? "500" : "normal",
                padding: "0 8px",
                height: "100%",
              }}
            >
              Initiation
            </span>
          }
          key="1"
        >
          <InitiationTab handleConfirmDeal={handleConfirmDeal} handleGoBack={handleGoBack} />
        </TabPane>
        <TabPane
          tab={
            <span
              style={{
                color: activeTab === "2" ? "#9F1AB1" : "inherit",
                backgroundColor: activeTab === "2" ? "#FDF4FF" : "",
                fontWeight: activeTab === "2" ? "500" : "normal",
                padding: "0 8px",
              }}
            >
              Booking
            </span>
          }
          key="2"
        >
          <BookingTab handlePreview={handlePreview} />
        </TabPane>
      </Tabs>
    </MainLayout>
  );
};

const InitiationTab = ({ handleConfirmDeal,handleGoBack }) => {
  return (
    <Card
      style={{
        // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
        marginTop: 20,
      }}
    >
      <div className="new-interbankplacement">
        <div style={{maxWidth:'560px'}}>
            <h2
              style={{ fontSize: "24px", fontWeight: "600", marginBottom: "-10px" }}
            >
              Deal Initiation
            </h2>
            <p style={{ color: "#666" }}>
              Add description text to note for users when adding the initiation
              information
            </p>

            <Form layout="vertical">
              <Form.Item
                label={
                  <span>
                    Deal Reference
                    <Tooltip title="Reference number for the deal">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                }
              >
                <Input
                  placeholder="727737748387838"
                  style={{
                    backgroundColor: "#f5f7f9",
                    border: "1px solid #e0e4e8",
                    borderRadius: "4px",
                  }}
                  disabled
                />
              </Form.Item>

              <div style={{ display: "flex", gap: "20px" }}>
                <Form.Item label="Deal Amount" style={{ flex: 1 }}>
                  <Input
                    placeholder="0.00"
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #e0e4e8",
                      borderRadius: "4px",
                    }}
                  />
                </Form.Item>

                <Form.Item label="Currency" style={{ flex: 1 }}>
                  <Select
                    placeholder="Select currency"
                    style={{ width: "100%" }}
                  >
                    <Option value="Pound-Sterling">Pound Sterling</Option>
                    <Option value="US-Dollar">US Dollar ($)</Option>
                    <Option value="Belize-Dollar">Belize Dollar(BZ$)</Option>
                    <Option value="Euro">Euro</Option>
                    <Option value="Nigerian-Naira">Nigerian Naira</Option>

                  </Select>
                </Form.Item>
              </div>

              <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                <Form.Item
                  label={
                    <span
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      Deal Tenor
                      <Tooltip title="Duration of the deal">
                        <InfoCircleOutlined style={{ color: "#888" }} />
                      </Tooltip>
                    </span>
                  }
                  style={{ flex: 1, minWidth: 250 }}
                >
                  <Input.Group compact style={{ display: "flex" }}>
                    <Input
                      style={{
                        width: "calc(100% - 80px)",
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "8px",
                      }}
                      placeholder="0"
                    />
                    <Select
                      defaultValue="days"
                      style={{
                        width: "80px",
                        
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderLeft: "none",
                      }}
                      dropdownStyle={{ borderRadius: "8px" }}
                    >
                      <Option value="days">days</Option>
                      <Option value="months">months</Option>
                      <Option value="years">years</Option>
                    </Select>
                  </Input.Group>
                </Form.Item>

                <Form.Item label="Proposed Rate" style={{ flex: 1, minWidth: 250 }}>
                  <Input
                    placeholder="0"
                    suffix={<PercentageOutlined />}
                    style={{
                      borderRadius: "8px",
                    }}
                  />
                </Form.Item>
              </div>

              <Form.Item
                label={
                  <span>
                    Notify Counter Party
                    <Tooltip title="Select or enter counter parties to notify">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                }
              >

              <Select
                  mode="tags"
                  placeholder="Select or enter counter parties"
                  style={{ width: "100%" }}
                  tokenSeparators={[","]}
                  options={[
                    { value: "All CounterParty", label: "All CounterParty" },
                    { value: "Access Bank", label: "Access Bank" },
                    { value: "Eco Bank", label: "Eco Bank" },
                    { value: "GT Bank", label: "GT Bank" },
                  ]}
                />
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "16px",
                  marginTop: "40px",
                }}
                className="interbankplacement"
              >
                <Button
                  style={{
                    borderRadius: "4px",
                    padding: "0 20px",
                    height: "40px",
                  }}
                  onClick={()=>handleGoBack()}
                  className="go-back-btn"
                >
                  Go back
                </Button>

                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#15CCAE",
                    borderColor: "#BA24D5",
                    borderRadius: "4px",
                    padding: "0 20px",
                    height: "40px",
                  }}
                  onClick={() => handleConfirmDeal()}
                >
                  Confirm deal
                </Button>
              </div>
            </Form>
        </div>
      </div>
    </Card>
  );
};

const BookingTab = ({ handlePreview }) => {
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  return (
    <Card
      style={{
        // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
        marginTop: 20,
      }}
    >
      <div className="booking">
        <h2
          style={{ fontSize: "24px", fontWeight: "600", marginBottom: "4px" }}
        >
          Booking
        </h2>
        <p style={{ color: "#666", marginBottom: "24px" }}>
          Add description text to note for users when adding a booking
          information
        </p>

        <Form layout="vertical" style={{paddingLeft:'32px',paddingRight:"32px"}}>
          {/* DEAL REFERENCE */}
          <div
            style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
          >
            <div style={{ flex: 1 }}>
              <Form.Item label="Deal Overview" style={{ fontWeight: 500 }}>
                <div style={{ height: "10px" }}></div>
              </Form.Item>
            </div>
            <div style={{ flex: 2 }}>
              <Form.Item label="Deal Reference">
                <Input
                  placeholder="727737748387838"
                  suffix={<EyeOutlined style={{ color: "#ccc" }} />}
                  style={{
                    backgroundColor: "#f5f7f9",
                    border: "1px solid #e0e4e8",
                    borderRadius: "4px",
                  }}
                  disabled
                />
              </Form.Item>

              <div style={{ display: "flex", gap: "20px",justifyContent:"center",alignItems:'center' }}>
                <div style={{ flex: 1 }} className="date-picker">
                  <Form.Item label="Deal Date" className="date-picker">
                    <DatePicker onChange={onChange} style={{width:'100%',height:"34px"}}/>                   
                  </Form.Item>
                </div>
                <div style={{ }}>
                  <Form.Item label="Deal Amount">
                    <Input
                      prefix={<span style={{ color: "#666" }}>$</span>}
                      placeholder="0.00"
                      suffix={
                        <Select
                          defaultValue="USD"
                          bordered={false}
                          style={{ width: "70px",height:'24px'}}
                        >
                          <Option value="USD">USD</Option>
                          <Option value="EUR">EUR</Option>
                          <Option value="GBP">GBP</Option>
                        </Select>
                      }
                    />
                  </Form.Item>
                </div>
              </div>

              <div style={{ display: "flex", gap: "20px",justifyContent:'center',alignItems:'center' }}>
                <div style={{ flex: 1 }}>
                  <Form.Item label="Value Date">
                    <Select placeholder="Settlement day" >
                      {/* <Option value="t0">T+0</Option>
                      <Option value="t1">T+1</Option>
                      <Option value="t2">T+2</Option> */}
                    </Select>
                  </Form.Item>
                </div>
                <div style={{ flex: 1 }}>
                  <Form.Item label="Maturity Date">
                    <DatePicker onChange={onChange} style={{width:"100%",height:"34px" }}/>  
                  </Form.Item>
                </div>
              </div>

              <div>
                <div style={{ flex: 1 }}>
                  <Form.Item
                    label={
                      <span>
                        Interest Rate
                        <Tooltip title="Interest rate information">
                          <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                        </Tooltip>
                      </span>
                    }
                  >
                    <Input placeholder="0" suffix="%" />
                  </Form.Item>
                </div>
                <div style={{ flex: 1 }}>
                  <Form.Item
                    label={
                      <span>
                        Interest Calculation Basis
                        <Tooltip title="Basis for interest calculation">
                          <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                        </Tooltip>
                      </span>
                    }
                  >
                    <Select placeholder="Select interest calculation basis">
                      <Option value="actual360">Actual/360</Option>
                      <Option value="actual365">Actual/365</Option>
                      <Option value="30360">30/360</Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>

          <Divider />

          {/* COUNTERPART BANK DETAILS */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              marginTop: "20px",
            }}
          >
            <div style={{ flex: 1 }}>
              <Form.Item
                label="Counterparty Bank Detail"
                style={{ fontWeight: 500 }}
              >
                <p style={{ fontSize: "12px", color: "#666", margin: "0" }}>
                  Choose currency type for product
                </p>
              </Form.Item>
            </div>
            <div style={{ flex: 2 }}>
              <div>
                <Form.Item
                  label={
                    <span>
                      Bank Name
                      <Tooltip title="Name of the bank">
                        <InfoCircleOutlined style={{ marginLeft: "5px"}} />
                      </Tooltip>
                    </span>
                  }
                >
              <Select
                mode="tags"
                placeholder="Select or enter counter parties"
                style={{ width: "100%",  }}
                tokenSeparators={[","]}
                options={[
                  { value: "All CounterParty", label: "All CounterParty" },
                  { value: "Access Bank", label: "Access Bank" },
                  { value: "Eco Bank", label: "Eco Bank" },
                  { value: "GT Bank", label: "GT Bank" },
                ]}
                
              />
                </Form.Item>
              </div>

              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 2 }}>
                  <Form.Item
                    label={
                      <span>
                        SWIFT/BIC Code
                        <Tooltip title="Bank identification code">
                          <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                        </Tooltip>
                      </span>
                    }
                  >
                    <Input placeholder="Enter---"/>
                  </Form.Item>
                </div>
              </div>

              <Divider />

              <div style={{ marginTop: "15px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    marginBottom: "16px",
                  }}
                >
                  Address
                </h3>

                <div style={{ display: "flex", gap: "20px" }}>
                  <div style={{ flex: 1 }}>
                    <Form.Item label="Country">
                      <Select placeholder="Select country" >
                        <Option value="us">United States</Option>
                        <Option value="uk">United Kingdom</Option>
                        <Option value="ca">Canada</Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ flex: 1 }}>
                    <Form.Item label="City">
                      <Select placeholder="Select country">
                        <Option value="ny">New York</Option>
                        <Option value="la">Los Angeles</Option>
                        <Option value="ch">Chicago</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>

                <Form.Item
                  label={
                    <span>
                      Street
                      <Tooltip title="Street address">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                >
                  <Input placeholder="Enter full address"/>
                </Form.Item>
              </div>

              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 1 }}>
                  <Form.Item
                    label={
                      <span>
                        Risk Rating
                        <Tooltip title="Risk rating information">
                          <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                        </Tooltip>
                      </span>
                    }
                  >
                    <Input
                      placeholder="Enter risk rating"
                      suffix={<InfoCircleOutlined style={{ color: "#ccc" }} />}
                    />
                  </Form.Item>
                </div>
                <div style={{ flex: 1 }}>
                  <Form.Item label="Exposure Limit">
                    <Input
                      prefix={<span style={{ color: "#666" }}>$</span>}
                      placeholder="000"
                      suffix="USD"
                    />
                  </Form.Item>
                </div>
              </div>

              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 1 }}>
                  <Form.Item label="Current Exposure">
                    <Input
                      prefix={<span style={{ color: "#666" }}>$</span>}
                      placeholder="000"
                      suffix="USD"
                      
                    />
                  </Form.Item>
                </div>
                <div style={{ flex: 1 }}>
                  <Form.Item label="Limit Expiry">
                    <Input placeholder="Enter limit expiry"/>
                  </Form.Item>
                </div>
              </div>

              <Divider />

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    marginBottom: "16px",
                  }}
                >
                  Dealing Officer
                </h3>

                <Form.Item
                  label={
                    <span>
                      Full name
                      <Tooltip title="Full name of dealing officer">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                >
                  <Input placeholder="Enter full name"/>
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Email
                      <Tooltip title="Email address">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                >
                  <Input placeholder="Enter contact email"/>
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Phone
                      <Tooltip title="Phone number">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                >
                  <Input placeholder="Enter phone number" />
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Dealing Room Phone
                      <Tooltip title="Dealing room phone number">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                >
                  <Input placeholder="Enter dealing room phone number" />
                </Form.Item>
              </div>
            </div>
          </div>

          <Divider />

          {/*SETTLEMENT INSTRUCTION  */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              marginTop: "20px",
            }}
          >
            <div style={{ flex: 1 }}>
              <Form.Item
                label="Settlement Instruction"
                style={{ fontWeight: 500 }}
              >
                <p style={{ fontSize: "12px", color: "#666", margin: "0" }}>
                  Manage your team members here.
                </p>
              </Form.Item>
            </div>
            <div style={{ flex: 2 }}>
              <Form.Item
                label={
                  <span>
                    Settlement Bank Name
                    <Tooltip title="Name of settlement bank">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                }
              >
               <Select
                mode="tags"
                placeholder="Select or enter counter parties"
                style={{ width: "100%"}}
                tokenSeparators={[","]}
                options={[
                  { value: "All CounterParty", label: "All CounterParty" },
                  { value: "Access Bank", label: "Access Bank" },
                  { value: "Eco Bank", label: "Eco Bank" },
                  { value: "GT Bank", label: "GT Bank" },
                ]}
                
              />
              </Form.Item>
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ height: "32px" }}></div>
            </div>
            <div style={{ flex: 2 }}>
              <Form.Item
                label={
                  <span>
                    Account Number
                    <Tooltip title="Account number information">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                }
              >
                <Input placeholder="Enter account number"/>
              </Form.Item>
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ height: "32px" }}></div>
            </div>
            <div style={{ flex: 2 }}>
              <Form.Item
                label={
                  <span>
                    Account Name
                    <Tooltip title="Name on the account">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                }
              >
                <Input placeholder="Enter account name"/>
              </Form.Item>
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ height: "32px" }}></div>
            </div>
            <div style={{ flex: 1 }}>
              <Form.Item label="Currency">
                <Select placeholder="Select currency">
                <Option value="Pound-Sterling">Pound Sterling (£)</Option>
                <Option value="US-Dollar">US Dollar($)</Option>
                <Option value="Belize-Dollar">Belize Dollar(BZ$)</Option>
                <Option value="Euro">Euro (€)</Option>
                <Option value="Nigerian-Naira">Nigerian Naira (₦)</Option>
                <Option value="Sound-Africa-Rand">Sound Africa Rand(R)</Option>
                </Select>
              </Form.Item>
            </div>
            <div style={{ flex: 1 }}>
              <Form.Item label="Value Date">
                <Select placeholder="Settlement day" >
                  {/* <Option value="t0"></Option>
                  <Option value="t1">T+1</Option>
                  <Option value="t2">T+2</Option> */}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ height: "32px" }}></div>
            </div>
            <div style={{ flex: 2 }}>
              <Form.Item label="Upload Agreement">
                <Upload.Dragger
                  style={{
                    padding: "20px",
                    border: "1px dashed #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <p
                    className="ant-upload-drag-icon"
                    style={{ marginBottom: "8px" }}
                  >
                    <UploadOutlined
                      style={{ fontSize: "24px", color: "#b026ff" }}
                    />
                  </p>
                  <p
                    style={{ color: "#b026ff", fontSize: "14px", margin: "0" }}
                  >
                    Click to upload{" "}
                    <span style={{ color: "#666" }}>or drag and drop</span>
                  </p>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "12px",
                      margin: "4px 0 0",
                    }}
                  >
                    SVG, PNG, JPG or GIF (max. 800x400px)
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "16px",
              marginTop: "40px",
            }}
            className="interbankplacement"
          >
            <Button
              style={{
                borderRadius: "4px",
                padding: "0 20px",
                height: "40px",
              }}
              className="go-back-btn"
            >
              Go back
            </Button>
            <Button
              type="primary"
              style={{
                backgroundColor: "#b026ff",
                borderColor: "#b026ff",
                borderRadius: "4px",
                padding: "0 20px",
                height: "40px",
              }}
              onClick={handlePreview}
            >
              Preview
            </Button>
          </div>
        </Form>
      </div>
    </Card>
  );
};

export default NewInterbankPlacement;
